import script from "./DialogBox.vue?vue&type=script&setup=true&lang=ts"
export * from "./DialogBox.vue?vue&type=script&setup=true&lang=ts"

import "./DialogBox.vue?vue&type=style&index=0&id=5657d8ee&lang=scss"

const __exports__ = script;

export default __exports__